module.exports = __webpack_public_path__ + "assets/img/55@3x.310dadab.png";